// extracted by mini-css-extract-plugin
export default {"item":"ProposalItem_item__mA9be"};